import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn:
    window.location.hostname === 'localhost'
      ? ''
      : 'https://58dc52b2bba04adf8f322c82fafafd93@o378525.ingest.sentry.io/5246990',
});
